import enterpriseActions from "../../web-sh/src/store/actions/enterprise"
import actionTypes from "../actionTypes"

const updateEnterpriseInvitations = invitations => {
  return {
    type: actionTypes.SET_ENTERPRISE_INVITATIONS,
    payload: invitations,
  }
}

export default {
  ...enterpriseActions,
  updateEnterpriseInvitations,
}